/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import BorderCenter from 'solis/react/board/hex/border.center';

import Lock from 'solis/react/board/icon/lock';


const getTransform = ({ hexGeometry, borderGeometry }) =>
{
  return `translate(${hexGeometry.getExternalWidth(0.15)}, 0) rotate(${- borderGeometry.getRotationDegrees()})`;
};


const Component = (props) =>
(
  <g transform = {getTransform(props)}>
    <Lock />
  </g>
);


export default (props) =>
{
  const { zoneData, hexGeometry, selected } = props;

  if (selected || !zoneData.isEstablished() || !hexGeometry.isEntityVisible())
  {
    return null;
  }

  return <BorderCenter {...props} Component = {Component} index = {1} />;
};
